// extracted by mini-css-extract-plugin
export default {"button":"HeaderCartButton_button__hehsW","icon":"HeaderCartButton_icon__97Uqj","badge":"HeaderCartButton_badge__Wy-B9","bump":"HeaderCartButton_bump__nEfMT"};